import { render, staticRenderFns } from "./auth-role-dialog.vue?vue&type=template&id=5aa8a0cf&scoped=true"
import script from "./auth-role-dialog.vue?vue&type=script&lang=js"
export * from "./auth-role-dialog.vue?vue&type=script&lang=js"
import style0 from "./auth-role-dialog.vue?vue&type=style&index=0&id=5aa8a0cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa8a0cf",
  null
  
)

export default component.exports